<template>

  <div>
    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :category-filter.sync="categoryFilter"
      :categories-options="categoriaOptions"
      @updateFilter="updatedFilter($event)"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="findAll"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(item_nome)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.item_nome)"
                :src="data.item.imagens.length > 0 ? data.item.imagens[0].caminho_imagem : null"
              />
            </template>
            <a
              :href="`${produtoBaseUrl}/${data.item.id}`"
              target="_blank"
              class="font-weight-bold d-block text-nowrap link-produto"
              style="color: inherit; cursor: pointer;"
            >
              {{ data.item.item_nome.length > 30 ? data.item.item_nome.substring(0, 30) + '...' : data.item.item_nome }}
            </a>
          </b-media>
        </template>

        <template #cell(preco)="data">
          <span
            v-if="data.item.tabela_preco_itens.length > 0"
            class="text-nowrap"
          >
            {{ data.item.tabela_preco_itens[0].preco_venda | currency }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            Não informado
          </span>
        </template>

        <template #cell(comissao)="data">
          <span 
            v-if="data.item.tabela_preco_itens.length > 0"
            class="text-nowrap"
          >
            {{ (data.item.comissao) + '%' }} <br>
            {{ ('R$ ' + calculateAfiliadoReceita(data.item.tabela_preco_itens[0].preco_venda, data.item.comissao)) }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            {{ (data.item.comissao) + '%' }}
          </span>
        </template>

        <template #cell(categoria)="data">
          <span
            v-if="data.item.categoria"
            class="text-nowrap"
          >
            {{ data.item.categoria.nome }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            -
          </span>
        </template>

        <template #cell(data_inclusao)="data">
          <span class="text-nowrap">
            {{ data.item.data_inclusao | formatDateTimeBr }}
          </span>
        </template>

        <!-- Column: Id -->
        <template #cell(id)="data">
          <b-link
            :to="{ name: 'app-adm-produto-view', params: { id: data.item.id }}"
            class="font-weight-bold"
          >
            #{{ data.item.id }}
          </b-link>
        </template>

        <template #cell(item_descricao)="data">
          <span>{{ data.value }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : data.item.ativo === 0 ? 'Inativo' : 'Deletado' }}
          </b-badge>
        </template>
        <template #head(actions)="data">
          <span>{{ data.label }}</span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <!-- <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('read', 'ADMIN_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Visualizar'"
              size="20"
              style="color: var(--secondary);"
              icon="EyeIcon"
              class="icon-activity"
              @click.stop="viewProduto(data.item.id)"
            />
            <feather-icon
                v-if="$can('update', 'ADMIN_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editCliente(data.item.id)"
            />
            <feather-icon
                v-if="$can('delete', 'ADMIN_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Deletar'"
              v-b-modal.modal-confirme-delete-cliente
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idProduto = data.item.id"
            />
          </div> -->
          <b-button
            v-if="$can('create', 'Afiliado')"
            v-b-modal.modal-pedido-afiliacao
            variant="success"
            @click="openPedidoModal(data.item)"
          >
            <span class="text-nowrap">
              Solicitar afiliação
            </span>
          </b-button>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalClientes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

      <b-modal
        id="modal-pedido-afiliacao"
        title="Pedido de Afiliação"
        ok-title="Enviar"
        cancel-title="Cancelar"
        @ok="handleSubmitPedido"
      >
        <b-form-group
          label="Mensagem do pedido de afiliação"
          label-for="texto-pedido"
        >
          <b-form-textarea
            id="texto-pedido"
            v-model="textoPedido"
            placeholder="Escreva aqui seu pedido de afiliação..."
            rows="4"
            max-rows="6"
          />
        </b-form-group>
      </b-modal>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-cliente"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir esse cliente?"
      @ok="deleteCategory"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onMounted, getCurrentInstance
} from '@vue/composition-api'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import router from '@/router'
import useProdutosListAll from '@/views/apps/produtos/list/useProdutosListAll'
import { currency, formatDateTimeBr, avatarText } from '@core/utils/filter'
import UsersListFilters from '../../list/ItemProdutoListFilters.vue'

export default {
  components: {
    UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
    BFormGroup,
    BFormTextarea,
  },
  filters: {
    currency,
    formatDateTimeBr,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    }
  },
  computed: {
    produtoBaseUrl() {
      const mode = process.env.MODE_APP
      if (mode === 'prod') {
        return 'https://avmarket.com.br/produto'
      }
      return 'https://hml.avmarket.com.br/produto'
    },
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const toast = useToast()
    const userData = JSON.parse(localStorage.getItem('userData'))
    console.log('userData', userData)

    const textoPedido = ref('')
    const itemSelecionado = ref(null)
    const percentualComissao = ref(null)
    const percentualEmpresa = ref(null)

    const getPadrinhoAfiliadoPercent = () => {
      if (userData?.comissao_padrinho !== null && userData?.comissao_validade !== null) {
        const validade = new Date(userData.comissao_validade)
        if (validade >= new Date()) {
          return Number(userData.comissao_padrinho) || 0
        }
      }
      return Number(percentualComissao.value) || 0
    }

    const getPadrinhoVendedorPercent = item => {
      console.log('item para pegar padrinho vendedor', item)
      const vendedor = item?.vendedores?.usuario
      
      if (vendedor?.comissao_padrinho !== null && vendedor?.comissao_validade !== null) {
        const validade = new Date(vendedor.comissao_validade)
        if (validade >= new Date()) {
          return Number(vendedor.comissao_padrinho) || 0
        }
      }
      
      // Se não tem padrinho válido, usa a configuração global
      return Number(percentualComissao.value) || 0
    }

    const getPlataformaPercent = item => {
      const percentual = item?.comissao_plataforma
        ?? item?.percentual_plataforma
        ?? item?.taxa_plataforma
      if (percentual !== null && percentual !== undefined) {
        return Number(percentual) || 0
      }
      return Number(percentualEmpresa.value) || 0
    }

    const calculateAfiliadoReceita = (preco, percentualAfiliado) => {
      const precoBase = Number(preco) || 0
      const percentual = Number(percentualAfiliado) || 0
      const valorAfiliado = precoBase * (percentual / 100)

      const valorFormatado = valorAfiliado.toFixed(2)
      return valorFormatado.endsWith('.00') ? Math.floor(valorAfiliado) : valorFormatado
    }

    const openPedidoModal = item => {
      itemSelecionado.value = item
      textoPedido.value = '' // Limpa o texto caso já tenha sido usado antes
    }

    const handleSubmitPedido = async () => {
      try {
        await axios.post('/linkafiliado', {
          id_afiliado: userData.id,
          uuid: '9ff1413e-adbb-4082-a750-f810c1091fc8',
          url_afiliado: `${proxy.produtoBaseUrl}/${itemSelecionado.value.id}?afiliado=${userData.afiliado.id}`,
          porcentagem_comissao: itemSelecionado.value.comissao,
          id_item: itemSelecionado.value.id,
          texto: textoPedido.value,
        })
        toast({
          component: ToastificationContent,
          props: {
            title: 'Solicitação enviada',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao criar afiliado',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        throw error
      }
    }

    const idProduto = ref(null)
    const blankCategoryData = ref({
      id: null,
      item_nome: '',
      item_descricao: '',
      id_categoria: '',
      ativo: 1,
      imagens: [],
    })

    const {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      categoriaOptions,
      categoryFilter,
    } = useProdutosListAll()

    const gruposOptions = ref([])

    const updatedFilter = e => {
      if (e.status) {
        statusFilter.value = e.status
      }
      if (e.id_categoria !== null) {
        const categoria = JSON.parse(JSON.stringify(e.id_categoria))
        categoryFilter.value = categoria.id
      }
      refetchData()
    }

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addCliente = async () => {
      blankCategoryData.value = {
        id: null,
        item_nome: '',
        item_descricao: '',
        id_categoria: '',
        ativo: 1,
        imagens: [],
      }
      isAddNewUserSidebarActive.value = true
    }

    const editCliente = id => {
      router.push({ name: 'app-adm-produto-add', params: { id } })
    }

    const viewProduto = id => {
      router.push({ name: 'app-adm-produto-view', params: { id } })
    }

    const deleteCategory = async () => {
      await store.dispatch('appAdmProdutos/delete', { id: idProduto.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idProduto.value = null
          refetchData()
        })
      refetchData()
    }

    onMounted(() => {
      store.dispatch('appAdmProdutos/findAll')
      axios.get('/comissao-config/1')
        .then(response => {
          percentualEmpresa.value = response.data.percentual_comissao
        })
        .catch(error => {
          console.error('Erro ao buscar configuração de comissão da empresa:', error)
        })
      if (userData.comissao_padrinho === null || (userData.comissao_validade !== null && new Date(userData.comissao_validade) < new Date())) {
        axios.get('/comissao-config/2')
          .then(response => {
            percentualComissao.value = response.data.percentual_comissao
          })
          .catch(error => {
            console.error('Erro ao buscar configuração de comissão:', error)
          })
      }
    })
    return {
      idProduto,
      addCliente,
      blankCategoryData,
      editCliente,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      updatedFilter,
      deleteCategory,
      viewProduto,
      categoriaOptions,
      categoryFilter,

      // Modal
      textoPedido,
      openPedidoModal,
      handleSubmitPedido,

      calculateAfiliadoReceita,
      percentualComissao,
      percentualEmpresa,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.link-produto {
  transition: color 0.2s;
  &:hover {
    color: #007bff !important; // Azul padrão Bootstrap
    text-decoration: underline;
  }
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
